/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../banking/common';
import '../banking/withholding_config_model';
import '../connect/v2/resources/error';
import './model';
import '../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "invest": {
        "nested": {
          "CreateBtcWithholdingConfigRequest": {
            "fields": {
              "owner": {
                "type": "squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              },
              "withholdingConfig": {
                "type": "squareup.banking.WithholdingConfig",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "CreateBtcWithholdingConfigResponse": {
            "fields": {
              "withholdingConfig": {
                "type": "squareup.banking.WithholdingConfig",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": "squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "CreateInvestmentAccountRequest": {
            "fields": {
              "owner": {
                "type": "squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              },
              "grantId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "accountRelationship": {
                "type": "squareup.invest.InvestmentAccountMetadata.AccountRelationship",
                "id": 3,
                "rule": "optional"
              },
              "accountType": {
                "type": "squareup.invest.AccountType",
                "id": 4,
                "rule": "optional",
                "options": {
                  "default": "BTC_TREASURY"
                }
              }
            }
          },
          "CreateInvestmentAccountResponse": {
            "fields": {
              "account": {
                "type": "squareup.invest.InvestmentAccountMetadata",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": "squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "DeactivateInvestmentAccountRequest": {
            "fields": {
              "owner": {
                "type": "squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              },
              "customerToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "DeactivateInvestmentAccountResponse": {
            "fields": {
              "accounts": {
                "type": "squareup.invest.InvestmentAccountMetadata",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "GetCurrentBitcoinPriceRequest": {
            "fields": {
              "owner": {
                "type": "squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "GetCurrentBitcoinPriceResponse": {
            "fields": {
              "currentBtcPrice": {
                "type": "squareup.connect.v2.common.Money",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "UpdateBtcWithholdingConfigRequest": {
            "fields": {
              "owner": {
                "type": "squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              },
              "withholdingConfig": {
                "type": "squareup.banking.WithholdingConfig",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "UpdateBtcWithholdingConfigResponse": {
            "fields": {
              "withholdingConfig": {
                "type": "squareup.banking.WithholdingConfig",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": "squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "ListRecentActivityRequest": {
            "fields": {
              "owner": {
                "type": "squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "ListRecentActivityResponse": {
            "fields": {
              "activities": {
                "type": "squareup.invest.InvestingActivity",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "ListInvestingActivityRequest": {
            "fields": {
              "owner": {
                "type": "squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              },
              "paginationToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "batchSize": {
                "type": "int32",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "ListInvestingActivityResponse": {
            "fields": {
              "activities": {
                "type": "squareup.invest.InvestingActivity",
                "id": 1,
                "rule": "repeated"
              },
              "paginationToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "ListInvestmentAccountsRequest": {
            "fields": {
              "owner": {
                "type": "squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              },
              "customerToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "ListInvestmentAccountsResponse": {
            "fields": {
              "accounts": {
                "type": "squareup.invest.InvestmentAccountMetadata",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "RetrieveBtcWithholdingRequest": {
            "fields": {
              "owner": {
                "type": "squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "RetrieveBtcWithholdingResponse": {
            "fields": {
              "withholdingConfig": {
                "type": "squareup.banking.WithholdingConfig",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "GetMaxWithholdingRequest": {
            "fields": {
              "owner": {
                "type": "squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "GetMaxWithholdingResponse": {
            "fields": {
              "withholdingBps": {
                "type": "uint32",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "RetrieveInvestEligibilityRequest": {
            "fields": {
              "owner": {
                "type": "squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "RetrieveInvestEligibilityResponse": {
            "fields": {
              "eligible": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "SweepPendingBalanceRequest": {
            "fields": {
              "unitToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "SweepPendingBalanceResponse": {
            "fields": {
              "success": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "InvestService": {
            "methods": {
              "CreateBtcWithholding": {
                "requestType": "squareup.invest.CreateBtcWithholdingConfigRequest",
                "responseType": "squareup.invest.CreateBtcWithholdingConfigResponse"
              },
              "CreateInvestmentAccount": {
                "requestType": "squareup.invest.CreateInvestmentAccountRequest",
                "responseType": "squareup.invest.CreateInvestmentAccountResponse"
              },
              "DeactivateInvestmentAccount": {
                "requestType": "squareup.invest.DeactivateInvestmentAccountRequest",
                "responseType": "squareup.invest.DeactivateInvestmentAccountResponse"
              },
              "GetCurrentBitcoinPrice": {
                "requestType": "squareup.invest.GetCurrentBitcoinPriceRequest",
                "responseType": "squareup.invest.GetCurrentBitcoinPriceResponse"
              },
              "UpdateBtcWithholding": {
                "requestType": "squareup.invest.UpdateBtcWithholdingConfigRequest",
                "responseType": "squareup.invest.UpdateBtcWithholdingConfigResponse"
              },
              "RetrieveBtcWithholding": {
                "requestType": "squareup.invest.RetrieveBtcWithholdingRequest",
                "responseType": "squareup.invest.RetrieveBtcWithholdingResponse"
              },
              "ListRecentActivity": {
                "requestType": "squareup.invest.ListRecentActivityRequest",
                "responseType": "squareup.invest.ListRecentActivityResponse"
              },
              "ListInvestingActivity": {
                "requestType": "squareup.invest.ListInvestingActivityRequest",
                "responseType": "squareup.invest.ListInvestingActivityResponse"
              },
              "ListInvestmentAccounts": {
                "requestType": "squareup.invest.ListInvestmentAccountsRequest",
                "responseType": "squareup.invest.ListInvestmentAccountsResponse"
              },
              "GetMaxWithholding": {
                "requestType": "squareup.invest.GetMaxWithholdingRequest",
                "responseType": "squareup.invest.GetMaxWithholdingResponse"
              },
              "RetrieveInvestEligibility": {
                "requestType": "squareup.invest.RetrieveInvestEligibilityRequest",
                "responseType": "squareup.invest.RetrieveInvestEligibilityResponse"
              },
              "SweepPendingBalance": {
                "requestType": "squareup.invest.SweepPendingBalanceRequest",
                "responseType": "squareup.invest.SweepPendingBalanceResponse"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.invest?.nested?.CreateBtcWithholdingConfigRequest && !$root.nested?.squareup?.nested?.invest?.nested?.CreateBtcWithholdingConfigResponse && !$root.nested?.squareup?.nested?.invest?.nested?.CreateInvestmentAccountRequest && !$root.nested?.squareup?.nested?.invest?.nested?.CreateInvestmentAccountResponse && !$root.nested?.squareup?.nested?.invest?.nested?.DeactivateInvestmentAccountRequest && !$root.nested?.squareup?.nested?.invest?.nested?.DeactivateInvestmentAccountResponse && !$root.nested?.squareup?.nested?.invest?.nested?.GetCurrentBitcoinPriceRequest && !$root.nested?.squareup?.nested?.invest?.nested?.GetCurrentBitcoinPriceResponse && !$root.nested?.squareup?.nested?.invest?.nested?.UpdateBtcWithholdingConfigRequest && !$root.nested?.squareup?.nested?.invest?.nested?.UpdateBtcWithholdingConfigResponse && !$root.nested?.squareup?.nested?.invest?.nested?.ListRecentActivityRequest && !$root.nested?.squareup?.nested?.invest?.nested?.ListRecentActivityResponse && !$root.nested?.squareup?.nested?.invest?.nested?.ListInvestingActivityRequest && !$root.nested?.squareup?.nested?.invest?.nested?.ListInvestingActivityResponse && !$root.nested?.squareup?.nested?.invest?.nested?.ListInvestmentAccountsRequest && !$root.nested?.squareup?.nested?.invest?.nested?.ListInvestmentAccountsResponse && !$root.nested?.squareup?.nested?.invest?.nested?.RetrieveBtcWithholdingRequest && !$root.nested?.squareup?.nested?.invest?.nested?.RetrieveBtcWithholdingResponse && !$root.nested?.squareup?.nested?.invest?.nested?.GetMaxWithholdingRequest && !$root.nested?.squareup?.nested?.invest?.nested?.GetMaxWithholdingResponse && !$root.nested?.squareup?.nested?.invest?.nested?.RetrieveInvestEligibilityRequest && !$root.nested?.squareup?.nested?.invest?.nested?.RetrieveInvestEligibilityResponse && !$root.nested?.squareup?.nested?.invest?.nested?.SweepPendingBalanceRequest && !$root.nested?.squareup?.nested?.invest?.nested?.SweepPendingBalanceResponse && !$root.nested?.squareup?.nested?.invest?.nested?.InvestService) {
  $root.addJSON(jsonData);
}

/**
 * Create a new btc withholding.
 * Using the existing banking withholding config proto.
 * TODO(dhuxley): Deprecate after moving to CreateInvestmentAccount
 *
 * SOURCE CreateBtcWithholdingConfigRequest @ squareup/invest/service.proto at 22:1
 */
export const CreateBtcWithholdingConfigRequest = $root.lookupType('squareup.invest.CreateBtcWithholdingConfigRequest');
fixType(CreateBtcWithholdingConfigRequest);
Builder.createAndAttachToType(CreateBtcWithholdingConfigRequest);
/**
 * TODO(dhuxley): Deprecate after moving to CreateInvestmentAccount
 *
 * SOURCE CreateBtcWithholdingConfigResponse @ squareup/invest/service.proto at 30:1
 */
export const CreateBtcWithholdingConfigResponse = $root.lookupType('squareup.invest.CreateBtcWithholdingConfigResponse');
fixType(CreateBtcWithholdingConfigResponse);
Builder.createAndAttachToType(CreateBtcWithholdingConfigResponse);
/**
 * If investment account does not yet exist for this merchant, follow the appropriate strategy
 * for the given AccountType.
 *
 * e.g. for BTC_INVEST:
 *  - Create `investment_account` record
 *  - Store Grantly grant_id, cash customer token
 *  - Create `withholding_config` record with enabled=false and bps=0
 *  - Register and store CCY_CLEARING account in bankc and banklin
 * If an account exists for merchant and has matching cash customer and grant_id exists,
 * return account.
 * If an account exists for merchant, but cash customer or grant_id do not match, error.
 *
 * SOURCE CreateInvestmentAccountRequest @ squareup/invest/service.proto at 48:1
 */
export const CreateInvestmentAccountRequest = $root.lookupType('squareup.invest.CreateInvestmentAccountRequest');
fixType(CreateInvestmentAccountRequest);
Builder.createAndAttachToType(CreateInvestmentAccountRequest);
/**
 * SOURCE CreateInvestmentAccountResponse @ squareup/invest/service.proto at 55:1
 */
export const CreateInvestmentAccountResponse = $root.lookupType('squareup.invest.CreateInvestmentAccountResponse');
fixType(CreateInvestmentAccountResponse);
Builder.createAndAttachToType(CreateInvestmentAccountResponse);
/**
 * SOURCE DeactivateInvestmentAccountRequest @ squareup/invest/service.proto at 60:1
 */
export const DeactivateInvestmentAccountRequest = $root.lookupType('squareup.invest.DeactivateInvestmentAccountRequest');
fixType(DeactivateInvestmentAccountRequest);
Builder.createAndAttachToType(DeactivateInvestmentAccountRequest);
/**
 * SOURCE DeactivateInvestmentAccountResponse @ squareup/invest/service.proto at 65:1
 */
export const DeactivateInvestmentAccountResponse = $root.lookupType('squareup.invest.DeactivateInvestmentAccountResponse');
fixType(DeactivateInvestmentAccountResponse);
Builder.createAndAttachToType(DeactivateInvestmentAccountResponse);
/**
 * SOURCE GetCurrentBitcoinPriceRequest @ squareup/invest/service.proto at 69:1
 */
export const GetCurrentBitcoinPriceRequest = $root.lookupType('squareup.invest.GetCurrentBitcoinPriceRequest');
fixType(GetCurrentBitcoinPriceRequest);
Builder.createAndAttachToType(GetCurrentBitcoinPriceRequest);
/**
 * SOURCE GetCurrentBitcoinPriceResponse @ squareup/invest/service.proto at 73:1
 */
export const GetCurrentBitcoinPriceResponse = $root.lookupType('squareup.invest.GetCurrentBitcoinPriceResponse');
fixType(GetCurrentBitcoinPriceResponse);
Builder.createAndAttachToType(GetCurrentBitcoinPriceResponse);
/**
 * SOURCE UpdateBtcWithholdingConfigRequest @ squareup/invest/service.proto at 77:1
 */
export const UpdateBtcWithholdingConfigRequest = $root.lookupType('squareup.invest.UpdateBtcWithholdingConfigRequest');
fixType(UpdateBtcWithholdingConfigRequest);
Builder.createAndAttachToType(UpdateBtcWithholdingConfigRequest);
/**
 * SOURCE UpdateBtcWithholdingConfigResponse @ squareup/invest/service.proto at 82:1
 */
export const UpdateBtcWithholdingConfigResponse = $root.lookupType('squareup.invest.UpdateBtcWithholdingConfigResponse');
fixType(UpdateBtcWithholdingConfigResponse);
Builder.createAndAttachToType(UpdateBtcWithholdingConfigResponse);
/**
 * SOURCE ListRecentActivityRequest @ squareup/invest/service.proto at 87:1
 */
export const ListRecentActivityRequest = $root.lookupType('squareup.invest.ListRecentActivityRequest');
fixType(ListRecentActivityRequest);
Builder.createAndAttachToType(ListRecentActivityRequest);
/**
 * SOURCE ListRecentActivityResponse @ squareup/invest/service.proto at 91:1
 */
export const ListRecentActivityResponse = $root.lookupType('squareup.invest.ListRecentActivityResponse');
fixType(ListRecentActivityResponse);
Builder.createAndAttachToType(ListRecentActivityResponse);
/**
 * SOURCE ListInvestingActivityRequest @ squareup/invest/service.proto at 96:1
 */
export const ListInvestingActivityRequest = $root.lookupType('squareup.invest.ListInvestingActivityRequest');
fixType(ListInvestingActivityRequest);
Builder.createAndAttachToType(ListInvestingActivityRequest);
/**
 * SOURCE ListInvestingActivityResponse @ squareup/invest/service.proto at 105:1
 */
export const ListInvestingActivityResponse = $root.lookupType('squareup.invest.ListInvestingActivityResponse');
fixType(ListInvestingActivityResponse);
Builder.createAndAttachToType(ListInvestingActivityResponse);
/**
 * SOURCE ListInvestmentAccountsRequest @ squareup/invest/service.proto at 111:1
 */
export const ListInvestmentAccountsRequest = $root.lookupType('squareup.invest.ListInvestmentAccountsRequest');
fixType(ListInvestmentAccountsRequest);
Builder.createAndAttachToType(ListInvestmentAccountsRequest);
/**
 * SOURCE ListInvestmentAccountsResponse @ squareup/invest/service.proto at 116:1
 */
export const ListInvestmentAccountsResponse = $root.lookupType('squareup.invest.ListInvestmentAccountsResponse');
fixType(ListInvestmentAccountsResponse);
Builder.createAndAttachToType(ListInvestmentAccountsResponse);
/**
 * SOURCE RetrieveBtcWithholdingRequest @ squareup/invest/service.proto at 120:1
 */
export const RetrieveBtcWithholdingRequest = $root.lookupType('squareup.invest.RetrieveBtcWithholdingRequest');
fixType(RetrieveBtcWithholdingRequest);
Builder.createAndAttachToType(RetrieveBtcWithholdingRequest);
/**
 * SOURCE RetrieveBtcWithholdingResponse @ squareup/invest/service.proto at 124:1
 */
export const RetrieveBtcWithholdingResponse = $root.lookupType('squareup.invest.RetrieveBtcWithholdingResponse');
fixType(RetrieveBtcWithholdingResponse);
Builder.createAndAttachToType(RetrieveBtcWithholdingResponse);
/**
 * SOURCE GetMaxWithholdingRequest @ squareup/invest/service.proto at 128:1
 */
export const GetMaxWithholdingRequest = $root.lookupType('squareup.invest.GetMaxWithholdingRequest');
fixType(GetMaxWithholdingRequest);
Builder.createAndAttachToType(GetMaxWithholdingRequest);
/**
 * SOURCE GetMaxWithholdingResponse @ squareup/invest/service.proto at 132:1
 */
export const GetMaxWithholdingResponse = $root.lookupType('squareup.invest.GetMaxWithholdingResponse');
fixType(GetMaxWithholdingResponse);
Builder.createAndAttachToType(GetMaxWithholdingResponse);
/**
 * SOURCE RetrieveInvestEligibilityRequest @ squareup/invest/service.proto at 136:1
 */
export const RetrieveInvestEligibilityRequest = $root.lookupType('squareup.invest.RetrieveInvestEligibilityRequest');
fixType(RetrieveInvestEligibilityRequest);
Builder.createAndAttachToType(RetrieveInvestEligibilityRequest);
/**
 * SOURCE RetrieveInvestEligibilityResponse @ squareup/invest/service.proto at 140:1
 */
export const RetrieveInvestEligibilityResponse = $root.lookupType('squareup.invest.RetrieveInvestEligibilityResponse');
fixType(RetrieveInvestEligibilityResponse);
Builder.createAndAttachToType(RetrieveInvestEligibilityResponse);
/**
 * SOURCE SweepPendingBalanceRequest @ squareup/invest/service.proto at 144:1
 */
export const SweepPendingBalanceRequest = $root.lookupType('squareup.invest.SweepPendingBalanceRequest');
fixType(SweepPendingBalanceRequest);
Builder.createAndAttachToType(SweepPendingBalanceRequest);
/**
 * SOURCE SweepPendingBalanceResponse @ squareup/invest/service.proto at 149:1
 */
export const SweepPendingBalanceResponse = $root.lookupType('squareup.invest.SweepPendingBalanceResponse');
fixType(SweepPendingBalanceResponse);
Builder.createAndAttachToType(SweepPendingBalanceResponse);
/**
 * Dashboard calls these.
 *
 * SOURCE InvestService @ squareup/invest/service.proto at 154:1
 */
export const InvestService = $root.lookupService('squareup.invest.InvestService');